export default "__VITE_ASSET__BM27Xcg6__"